window.__tnt || (window.__tnt = {});
window.__tnt.subscription || (__tnt.subscription = {});
window.__tnt.subscription.d || (__tnt.subscription.d = []);
window.__tnt.subscription.access.manifest || (window.__tnt.subscription.access.manifest = {
    denied: {
        promise: null,
        resolve: function(){ }
    }, 
    granted: {
        promise: null,
        resolve: function(){ }
    }
});

window.tntPurchase = document.createEvent('Event');
    tntPurchase.initEvent('tnt-purchase',true,true,{});

window.tntSignup = document.createEvent('Event');
    tntSignup.initEvent('tnt-signup',true,true,{});

/** 
 * Access Denied - Occlude Content
 */
window.__tnt.subscription.d.push(function(oResp){
    var content = document.getElementById('asset-content'),
        eedition = document.getElementById('eedition-wrapper'),
        wallBehavior = oResp.access_rule.wall_behavior,
        encryptedContent = null,
        subscriberOnly = null;

    if(wallBehavior!="nag"){
        if(eedition){ content = eedition }
        if(content){ content.hidden = true }
    }else if(content){
    // in nag mode display unencrypted content
        encryptedContent = content.querySelector(".subscriber-only.encrypted-content");
        subscriberOnly = content.querySelectorAll(".subscriber-only,.subscriber-hide");

        if(subscriberOnly && !encryptedContent){
            subscriberOnly.forEach(function(el){ el.style.display = "" });
        }
    }
});

/**
 * Access Denied - Display Access Offers Modal
 * - falls back to methods if no offers are available
 */
window.__tnt.subscription.d.push(function(oResp){
    var subscriptionTypeMethods = 0,
        accessWallSubscription = document.getElementById('access-wall-subscription'),
        aServiceIds = [],
        content = document.getElementById('asset-content'),
        logData = [],
        pos = 1,
        previewMode = false,
        modalEl = document.getElementById('access-offers-modal'),
        activeTab = modalEl.querySelector('.modal-content.active'),
        offersTab = document.getElementById('modal-offers-tab'),
        offersTemplate = offersTab.querySelector('template.template-promo-service'),
        offersDescription = document.getElementById('access-modal-description'),
        offersOutput = offersTab.querySelector('.output'),
        servicePanelClasses = "promotion-service subscription-service panel panel-default",
        purchaseTab = document.getElementById('user-modal-tab-purchase'),
        purchaseForm = document.getElementById('form-super-purchase'),
        purchaseRateDisplay = document.getElementById('user-purchase-rate'),
        siteNameEl = document.head.querySelector('meta[property="og:site_name"]'),
        siteName = "",
        bFoundUserMethod = false,
        bFoundOtherMethod = false,
        loginTab = document.getElementById('user-modal-tab-login'),
        signupTab = document.getElementById('user-modal-tab-signup');
    
    /* Ensure tax storage is clear */
    sessionStorage.removeItem('__tnt.service.rate.tax');
    sessionStorage.removeItem('__tnt.service.rate.total');

   if(modalEl.hasAttribute('data-preview')){ previewMode = true }
   if(siteNameEl){ siteName = siteNameEl.content }

    if(!Array.isArray(oResp.offer_config)){
/* OFFERS DISPLAY */

        if(oResp.offer_config.offers){
            offersOutput.innerHTML = "";

            if(oResp.offer_config.message && offersDescription){ 
                offersDescription.innerHTML = oResp.offer_config.message;
                offersDescription.classList.add('padding-bottom');
            }else{
                offersDescription.innerHTML = "";
                offersDescription.classList.remove('padding-bottom');
            }
            
            // Modal Title
            offersTab.querySelector('.offer-group-title').innerHTML = oResp.offer_config.title;

            // Size modal
            if (oResp.offer_config.offers.length <= 2) {
                modalEl.classList.add('modal-small');
            }else{
                modalEl.classList.remove('modal-small');
            }

            oResp.offer_config.offers.forEach(function(offer){

                var description = offer.description,
                    buttonText = "Get Started",
                    image = '',
                    imageLayout = 'horizontal',
                    ratePrice = 0,
                    currency = "none",
                    sku = "",
                    productName = "",
                    productId = offer.service_id || offer.id;
                    
                if(offer.button_text){ buttonText = offer.button_text }
                if(offer.rate_price){ ratePrice = Number(offer.rate_price) / 100 }
                if(offer.rate_currency){ currency = offer.rate_currency }
                if(offer.rate_id){ sku = offer.rate_id }
                if(offer.service_name){ productName = offer.service_name;
                } else { productName = offer.title }

                if(offer.image){
                    image = '<figure class="photo layout-' + imageLayout + ' padding-bottom"><div class="image"><img class="img-responsive full default" src="' + offer.image + '" alt="' + offer.title + '"/></div></figure>';
                }

                /* 
                 * Initialize Product Data
                 */
                productData = {
                    'product_id': productId,            // subscription service id or offer id
                    'sku': sku,                         // offer rate id
                    'name': productName,                // title of the service
                    'url': offer.link_url,              // the current url being displayed? Or is this supposed to be the offer's link url?
                    'position': pos,                    // same as the position count in the impression
                    'image_url': offer.image,           // image returned by the offer
                    'quantity': 1,                      // always 1 for subscriptions
                    'coupon': "",                       // coupon code entered by the user
                    'category': oResp.offer_config.name,// name of the offer group
                    'price': ratePrice,                 // price of the offer in dollar.cents
                    'variant': offer.rate,              // name of the rate and not the rate id?
                    'brand': siteName,                  // the sites brand label
                    'currency': currency,               // the currency code of the money used for this item
                    'viewed_from': "Article",           // type of view of the product internal use
                    'legacy_context': "Article"         // Legacy view data Article/Block/Dashboard
                }

                /*
                 * Elements to modify within the template element before it is added to the DOM and displayed to the user.
                 */
                var elements = [
                    {
                        'element' : '.subscription-service.panel',
                        'attr' : [
                            {
                                'attr' : 'class',
                                'value' : servicePanelClasses
                            },
                            {
                                'attr' : 'data-offer-id',
                                'value' : offer.id
                            }
                        ]
                    },{
                        'element' : '.method-header',
                        'html' : offer.title
                    },{
                        'element' : '.method-image',
                        'html' : image
                    },{
                        'element' : '.offer-rate',
                        'html' : offer.rate
                    },{
                        'element' : '.offer-limits',
                        'html' : offer.limits
                    },{
                        'element' : '.offer-cycle',
                        'html' : offer.billing_cycle
                    },{
                        'element' : '.offer-savings',
                        'html' : offer.savings
                    },{
                        'element' : '.offer-cancel',
                        'html' : "Cancel anytime"
                    },{
                        'element' : '.method-description',
                        'html' : description
                    }
                ];
                
                /* Link Handling */
                if(offer.service_id!=null && offer.rate_id != null){
                    elements.push({
                        'element' : 'a.method-link',
                        'html' : buttonText,
                        'attr' : [
                            {
                                'attr' : 'class',
                                'value' : "method-link btn btn-danger btn-lg"
                            },{
                                'attr' : 'data-subscription-service',
                                'value' : offer.service_id
                            },{
                                'attr' : 'data-subscription-rate',
                                'value' : offer.rate_id
                            },{
                                'attr' : 'data-subscription-rate-name',
                                'value' : offer.rate
                            },{
                                'attr' : 'data-name',
                                'value' : offer.title
                            },
                            {
                                'attr' : 'data-product',
                                'value' : JSON.stringify(productData)
                            }
                        ]
                    });
                }else if(offer.link_js){
                    elements.push({
                        'element' : 'a.method-link',
                        'html' : buttonText,
                        'attr' : [
                            {
                                'attr' : 'class',
                                'value' : "method-link btn btn-danger btn-lg"
                            },{
                                'attr' : 'href',
                                'value': 'javascript:void(0)' 
                            },{
                                'attr': 'onClick',
                                'value': offer.link_js
                            },{
                                'attr' : 'data-name',
                                'value' : offer.title
                            }
                        ]
                    });
                }else{
                    elements.push({
                        'element' : 'a.method-link',
                        'html' : buttonText,
                        'attr' : [
                            {
                                'attr' : 'class',
                                'value' : "method-link btn btn-danger btn-lg"
                            },{
                                'attr' : 'href',
                                'value' : offer.link_url
                            },{
                                'attr' : 'data-name',
                                'value' : offer.title
                            }
                        ]
                    });
                }

                /* Featured Message */
                if(offer.featured_message){
                    elements.push({
                        'element' : '.method-featured',
                        'html' : '<span class="featured-icon"></span><span class="featured-message">' + offer.featured_message + '</span>',
                        'attr' : [
                            {
                                'attr' : 'class',
                                'value' : 'method-featured featured-' + offer.featured
                            }
                        ]
                    });
                }

                __tnt.template(
                    offersTemplate, // template element
                    offersOutput,   // output element
                    false,           // add items from start of output
                    elements,       // elements in template to modify
                    function(t){    // callback to run after template is added

                        t.querySelector('a.method-link').addEventListener('click',function(ev){
                            ev.preventDefault();

                            if(ev.target.getAttribute('data-subscription-service')){
                                var serviceId = ev.target.getAttribute('data-subscription-service'),
                                    serviceName = ev.target.getAttribute('data-name'),
                                    rateId = ev.target.getAttribute('data-subscription-rate'),
                                    ratePrice = JSON.parse(ev.target.dataset.product).price,
                                    fetchUrl = "/tncms/subscription/services/",
                                    searchParams = new URLSearchParams();

                                if(serviceId){ searchParams.append('service_id', serviceId) }
                                if(rateId){ searchParams.append('rate_id', rateId) }
                            
                                fetch(fetchUrl + "?" + searchParams.toString(),{
                                   headers: {
                                       'X-Requested-With': 'XMLHttpRequest'
                                    }
                                }).then(function(oResp){
                                    if(oResp.ok){ oResp.json().then(function(oData){
                                        var purchaseForm = document.getElementById('form-super-purchase'),
                                            oRate = null,
                                            iRate = 0,
                                            sPrice = ev.target.getAttribute('data-subscription-rate-name'),
                                            sDurationUnit = "days";
                                        
                                        purchaseForm.reset();

                                        purchaseForm.elements.service_id.value = serviceId;
                                        purchaseForm.elements.rate_id.value = rateId;
                                        purchaseForm.elements.rate_price.value = ratePrice;

                                        if(Array.isArray(oData[0].rates)){
                                            while(!oRate && iRate < oData[0].rates.length && iRate < 5){
                                                if(oData[0].rates[iRate].id == rateId){ oRate = oData[0].rates[iRate] }
                                            
                                                iRate++;
                                            }
                                        }

                                        if(oRate){
                                            if(oRate.duration > 7){ purchaseForm.querySelector('.service-renews').hidden = false; }
                                            if(oRate.duration == 1){ sDurationUnit = "day" }
                                            
                                            sPrice = "$" + (oRate.price/100) + " for " + oRate.duration + " " + sDurationUnit;
                                        }
        
                                        var purchaseRateTemplate = purchaseRateDisplay.querySelector('template'),
                                            purchaseRateOutput = purchaseRateDisplay.querySelector('.output'),
                                            elements = [
                                                {
                                                   'element' : '.rate-name',
                                                   'html' : offer.title
                                                },{
                                                    'element' : '.rate-price',
                                                    'html' : offer.rate
                                                },{
                                                    'element' : '.service-description',
                                                    'html' : offer.description
                                                },{
                                                    'element' : 'a.service-link',
                                                    'attr': [{
                                                        'attr': 'href',
                                                        'value': offer.link_url
                                                    }]
                                                }
                                                
                                            ];
        
                                        purchaseRateOutput.innerHTML = "";
                                        __tnt.template(purchaseRateTemplate, purchaseRateOutput, false, elements, function(t){
                                            t.querySelector('.rate-info').addEventListener('click',function(ev){
                                                var rateEl = document.getElementById('user-purchase-rate'),
                                                    rateExpand = document.getElementById('user-purchase-rate').querySelector('.service-rate .rate-info-expander');

                                                rateEl.classList.toggle('expanded');
                                                rateEl.querySelector('.service-rate .service-details').classList.toggle('hide');
                                                rateExpand.querySelector('.collapsed').classList.toggle('hide');
                                                rateExpand.querySelector('.expanded').classList.toggle('hide');
                                            });

                                            var locationFields = purchaseTab.querySelector('.delivery-location-required'),
                                                bDeliveryRequired = false;
                                                    
                                            if(oData[0].delivery_required){ bDeliveryRequired = true }   
                                            if(locationFields && bDeliveryRequired){ locationFields.hidden = false
                                            } else if(locationFields) { locationFields.hidden = true }

                                            purchaseForm.dispatchEvent(tntPurchase);
                                            __tnt.subscription.access.showTab(purchaseTab, modalEl.id, 'access-methods');

                                            // LOG productDetail
                                            __tnt.subscription.offers.logDetails("Article");

                                            __tnt.subscription.handleCart(oRate, serviceId, serviceName, siteName);
 
                                        });
                                        
                                        // Adjust form for purchase type
                                        __tnt.subscription.offers.purchaseType(purchaseForm, productData);
                                        
                                        // Tax consideration
                                        __tnt.subscription.offers.purchaseTax(oData, purchaseForm, productData);
                                    }); }
                                });

                               // #LOG productClick
                               if(this.getAttribute('data-product')){
                                   var productData = JSON.parse(ev.target.getAttribute('data-product'));

                                    __tnt.subscription.offers.logClick(productData);
                                }
                                
                            }else{
                               if(this.getAttribute('data-product')){
                                    var productData = JSON.parse(ev.target.getAttribute('data-product'));

                                    __tnt.subscription.offers.logClick(productData);
                                }        
                            
                                if(ev.target.href!="javascript:void(0)"){
                                    document.location = ev.target.href;
                                }
                            }
                        }); // End of click
                        
                        var offerId = offer.id;
                        if(offer.service_id){ offerId = offer.service_id }

                        // #LOG Build Impression
                        logData.push({
                            impressionData: {
                                'id':offerId,
                                'name':offer.title,
                                'price':ratePrice,
                                'variant':offer.rate,
                                'brand':siteName,
                                'category': 'subscription',
                                'list':'Article',
                                'position':pos
                            },
                            offerData: offer,
                            offerGroupId: oResp.offer_config.id,
                            offerGroupName: oResp.offer_config.name,
                            offerContext: "paywall",
                            paywallDisplay: 'modal',
                            productData: productData
                        });

                        pos++;
                    
                }); // end of template addition
            });
        }

/* END OF OFFERS */
    }else{
/* ACCESS METHODS FALLBACK */

        if(oResp && oResp.access_methods && oResp.access_methods.length){
            for(i=0;i<oResp.access_methods.length;i++){
                var method = oResp.access_methods[i];

                if(oResp.access_methods[i].type=="subscription"){
                    subscriptionTypeMethods++;
                }

                if(method && method.metadata){
                    aServiceIds.push(method.metadata.service_id);
                }

                if(method && method.type && method.type == "user"){ bFoundUserMethod = true
                }else{ bFoundOtherMethod = true }
            }
        }

        var serviceModal = document.getElementById('access-offers-modal'),
            toHide = null,
            toRemove = null;
            
        if(content && serviceModal){
            toHide = content.querySelectorAll('.subscriber-hide,.subscriber-remove,.subscriber-only');
            
            serviceModal.classList.remove('access-offers-wrapper');
            serviceModal.classList.remove('access-offers-modal');
            serviceModal.classList.add('access-methods-modal');
        }
    
        if(serviceModal){
            var modalTitle = offersTab.querySelector('.offer-group-title'),
                modalDesc = document.getElementById('access-modal-description');
            
            // Size modal
            if (subscriptionTypeMethods <= 2) {
                serviceModal.classList.add('modal-small');
            }

            if(oResp.access_rule.message != null) {
                // Populate modal title and description
                offersDescription.innerHTML = oResp.access_rule.message.description;
                offersDescription.classList.add('padding-bottom');
                offersTab.querySelector('.offer-group-title').innerHTML = oResp.access_rule.message.title;
            } else {
                offersDescription.innerHTML = "";
                offersDescription.classList.remove('padding-bottom');
            }

            var modalEl = document.getElementById('access-offers-modal'),
                methodsEl = null,
                outputEl = null,
                accessSubscription = false,
                siteNameEl = document.head.querySelector('meta[property="og:site_name"]'),
                siteName = "",
                pos = 1,
                previewMode = false;

            if(modalEl){ methodsEl = document.getElementById('access-methods') }
            if(methodsEl){ outputEl = document.getElementById('access-methods') }
            if(siteNameEl){ siteName = siteNameEl.content }
            if(modalEl.hasAttribute('data-preview')){ previewMode = true }
    
            if(oResp.access_methods && oResp.access_methods.length && methodsEl){
                methodsEl.innerHTML = "";

                for(var am = 0; am < oResp.access_methods.length; am++){
                    var method =  oResp.access_methods[am];
                        sType = method.type;

                    if(sType == "customjavascript" && method.response.type){ sType = method.response.type;
                    }else if(sType == "customjavascript"){ sType = "custom_javascript"; }

                    if(typeof(__tnt.subscription.access.output[sType])=="function"){         
                        var template = modalEl.querySelector('template.template-promo-service'),
                            wrapper = outputEl,
                            output = __tnt.subscription.access.output[sType](method, pos),
                            elements = [],
                            callback = function(){ return false; },
                            refererUrl = "";

                            if(output.elements){ elements = output.elements; }
                            if(typeof(output.callback)){ callback = output.callback; }
                            if(wrapper){ refererUrl = wrapper.getAttribute('data-referer') }

                        __tnt.template(template, wrapper, false, elements, function(t){
                            t.querySelector('.method-featured').remove();
                        
                            t.querySelector('.method-link').addEventListener('click',function(ev){
                                ev.preventDefault();

                                var el = ev.target,
                                    serviceId,
                                    serviceName,
                                    serviceUrl,
                                    siteNameEl = document.head.querySelector('meta[property="og:site_name"]'),
                                    siteName = "",
                                    linkEl = ev.target,
                                    limiter = 0,
                                    userModalEl = document.getElementById('access-offers-modal');

                                    if(siteNameEl){ siteName = siteNameEl.content }
    
                                while(linkEl.tagName != "A" && limiter < 3){
                                    if(linkEl.tagName != "A"){
                                        linkEl = linkEl.parentNode;
                                    }
                                    limiter++;
                                }
    
                                if(linkEl){
                                    serviceId = linkEl.dataset.subscriptionService;
                                    serviceName = linkEl.dataset.name;
                                    serviceUrl = linkEl.href;
                                }

                                if(window.sessionStorage){
                                    try{
                                        sessionStorage.setItem('__tnt.service.list', 'Article');
                                    }catch(error){}
                                }

                                // LOG click
                                if(!previewMode){
                                   if(ev.target){
                                        /* Get product data from target element */
                                        var productData = JSON.parse(ev.target.getAttribute('data-product'));
                    
                                        __tnt.subscription.offers.logClick(productData); // #LOG this may need a callback to handle the link url for methods
                                    }

                                    document.location = serviceUrl;

                                }else{
                                    document.location = serviceUrl;
                                }
                            });

                            // impression
                            var impressionServiceId = method.id;
                            if(method.metadata.service_id){ impressionServiceId = method.metadata.service_id }

                            logData.push({
                                impressionData: {
                                    'id':impressionServiceId,
                                    'name':method.name,
                                    'price':0,
                                    'variant':'',
                                    'brand':siteName,
                                    'category': 'subscription',
                                    'list':'Article',
                                    'position':pos
                                }
                            });

                            pos++;
                        }); // end template

                    }
                }// end of for loop
            }// end of methods check

        } /* end of service modal check */
        
        
/* END OF METHODS FALLBACK */
    }

    // hide any other active tabs
    if(activeTab && offersTab){
        activeTab.classList.add('hide');
        activeTab.classList.remove('active');
        
        if(bFoundUserMethod && !bFoundOtherMethod && loginTab && signupTab){
            var signupForm = signupTab.querySelector('form');
        
            serviceModal.classList.add('access-offers-wrapper');
            serviceModal.classList.add('access-offers-modal');
            serviceModal.classList.remove('access-methods-modal');
        
            // show signup tab
            signupTab.classList.remove('hide');
            signupTab.classList.add('active');
            
            if(signupForm){ signupForm.dispatchEvent(tntSignup) }

            // back buttons aren't useful in this state
            try{
                loginTab.querySelector('.tab-back').remove();
                signupTab.querySelector('.tab-back').remove();
            }catch(e){ }

            // populate header and message
            var signupHeading = signupTab.querySelector('.modal-header h3');
            
            if(oResp.access_rule.message && oResp.access_rule.message.title){
                try{
                    if(oResp.access_rule.message.description){
                        var messageEl = document.createElement('p');
                            messageEl.innerHTML = oResp.access_rule.message.description;
                            messageEl.classList.add('text-center');
                            
                        signupTab.querySelector('.modal-header').appendChild(messageEl);
                        signupHeading.classList.add('padding-bottom');
                    }
                
                    signupHeading.innerHTML = oResp.access_rule.message.title;
                
                }catch(e){ }
            }

        }else{
            // show offers tab
            __tnt.subscription.access.showTab(offersTab, 'access-offers-modal', 'access-methods');
        }
    }else if(offersTab){
        __tnt.subscription.access.showTab(offersTab, 'access-offers-modal', 'access-methods');
    }else{
    }

/** finally open the modal */
    $(modalEl).find('.modal').modal('show');

    // LOG Impressions
    if (!__tnt.subscription.offers.impressionLogged) {
        __tnt.subscription.offers.logImpression(logData);
        __tnt.subscription.offers.impressionLogged = true;
    }

});



/**
 * Access Denied - Log display of wall, and set displayed rule data
 */
window.__tnt.subscription.d.push(function(oResp){
    var accessRuleId = null;

    if(oResp.access_rule){
        __tnt.trackEvent({'category':'subscription','action':'wall','label':oResp.access_rule.name,'value':0});

        try{
            if(window.localStorage){
                accessRuleId = window.localStorage.getItem('tnt:access:rule');
                
                if(oResp.access_rule.id != accessRuleId){
                    localStorage.setItem('tnt:access:rule', oResp.access_rule.id);
                    localStorage.setItem('tnt:access:rule:name', oResp.access_rule.name);
                    __tnt.trackEvent({'category':'Access Control','action':'Access Rule Change','label':oResp.access_rule.name,'value':''});
                }

            }
        }catch(e){}
    }
});

__tnt.subscription.access.manifest.denied.resolve();
